import React from 'react';
import { useIntl } from 'react-intl';
import styled, { keyframes } from 'styled-components';

import { Icons } from '../Icons';
import { ColorKeys } from '../styles/themes';
import { MarginProps } from '../utils/mixins';
import messages from './messages';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const SpinningIcon = styled(Icons.Processing)`
  animation: ${spin} 2s linear infinite;
`;

type LoadingSpinnerProps = MarginProps & {
  size?: string;
  color?: ColorKeys;
  className?: string;
};

export const LoadingSpinner = ({
  size = '1em',
  color = 'currentColor',
  ...rest
}: LoadingSpinnerProps) => {
  const { formatMessage } = useIntl();

  return (
    <SpinningIcon
      size={size}
      color={color}
      noPadding
      aria-label={formatMessage(messages.loading)}
      {...rest}
    />
  );
};
